<img
  [attr.alt]="alt()"
  [attr.aria-hidden]="ariaHidden()"
  [attr.class]="className()"
  [attr.loading]="loading()"
  [src]="'../../../assets/icons/' + src()"
  [height]="height()"
  [width]="width()" />
